import { Tooltip } from 'antd';
import React, { memo, useCallback, useState } from 'react';
import { attachmentsActions } from '../../../actions/attachments.actions';
import { PictureIcon } from '../../../resource/icons';
import LightboxGroup from '../../LightboxGroup/LightboxGroup';
import parentTypes from '../constants/parentTypes';

const PicturePreviewIcon = ({
  parentId,
  attachment,
  allAttachments,
  parentType,
  getPreviewAttachment,
}) => {
  const [showPreview, setShowPreview] = useState(false);

  const loader = useCallback(
    (fileName) =>
      getPreviewAttachment
        ? getPreviewAttachment(parentId, fileName)
        : attachmentsActions.previewAttachment(
            parentId,
            fileName,
            parentTypes[parentType]
          ),
    [parentId, parentType]
  );

  const closePreview = useCallback(() => setShowPreview(false));
  const onOpenPreview = useCallback(() => {
    setShowPreview(attachment);
  }, [attachment.id]);

  return (
    <>
      <Tooltip title={'Просмотр'}>
        <PictureIcon onClick={onOpenPreview} />
      </Tooltip>
      <LightboxGroup
        visible={!!showPreview}
        onClose={closePreview}
        attachments={allAttachments}
        attachment={showPreview}
        loader={loader}
      />
    </>
  );
};

export default memo(PicturePreviewIcon);
